import { convertToExportedView } from '@estee/elc-service';
import { IBuyOnlinePickupInStoreModal } from './BuyOnlinePickupInStoreModal';
import serviceNames from '~setup/StoresService';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<IBuyOnlinePickupInStoreModal>(
    () => import('./BuyOnlinePickupInStoreModal'),
    'buy-online-pickup-in-store-modal',
    serviceNames.storesViewController
);
